import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'substr'
})
export class SubstrPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
